import React, { useState, useEffect } from 'react';
import { Card, Spin, Table } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { formatCurrency } from '../../../helpers/utils';
import SnapshotService from '../services';
import CardEmptyResult from 'components/common/pageComponents/CardEmptyResult';
import { PiInfoDuotone } from 'react-icons/pi';

const NetIncomeByFiscalYear = ({ years }) => {
  const [data, setData] = useState([]);
  const [currency, setCurrency] = useState({ currency_symbol: '$', currency_code: 'USD' });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [years]);

  const fetchData = () => {
    setIsLoading(true);
    const params = {};
    if (years && Array.isArray(years) && years.length > 0) {
      params.years = years;
    }
    
    SnapshotService.getNetIncomeByFiscalYear(params)
      .then((response) => {
        if (response.data?.success) {
          setData(response.data.data?.data || response.data.data || []);
          setCurrency(response.data.data?.currency || response.data.currency || { currency_symbol: '$', currency_code: 'USD' });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching net income:', error);
        setIsLoading(false);
      });
  };

  const columns = [
    {
      title: 'Fiscal Year',
      dataIndex: 'year',
      key: 'year',
      render: (year) => <strong>{year}</strong>,
    },
    {
      title: 'Income',
      dataIndex: 'income',
      key: 'income',
      align: 'right',
      render: (income) => formatCurrency(income, currency.currency_symbol),
    },
    {
      title: 'Expense',
      dataIndex: 'expense',
      key: 'expense',
      align: 'right',
      render: (expense) => formatCurrency(expense, currency.currency_symbol),
    },
    {
      title: 'Net Income',
      dataIndex: 'net_income',
      key: 'net_income',
      align: 'right',
      render: (netIncome) => (
        <strong style={{ color: netIncome >= 0 ? '#52c41a' : '#ff4d4f' }}>
          {formatCurrency(netIncome, currency.currency_symbol)}
        </strong>
      ),
    },
  ];

  if (isLoading) {
    return (
      <Card title="Net Income">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <Spin indicator={<LoadingOutlined spin />} />
        </div>
      </Card>
    );
  }

  if (!data.length) {
    return (
      <CardEmptyResult
        title="No net income data"
        subtitle="There is no net income data available for the selected fiscal years."
        icon={<PiInfoDuotone className="fs-2 text-secondary" />}
      />
    );
  }

  return (
      <Table
        columns={columns}
        dataSource={data.map((item, index) => ({ ...item, key: item.year || index }))}
        pagination={false}
        size="small"
      />
  );
};

export default NetIncomeByFiscalYear;

